import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from 'owa-bundling';
import { Loading, NetworkError } from 'owa-interstitial';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "SpaceManagement" */ './lazyIndex'),
    { name: 'SpaceManagement' }
);

export const SpaceManagementDashboard: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.SpaceManagementDashboard,
    Loading,
    NetworkError
);

export const lazyPlacesManagementModule: LazyImport<
    typeof lazyIndex,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m);
